import { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import toast from 'react-hot-toast';
import CustomButton from '../../../common/CustomButton';

function SignupLink({ organization }) {
    const aRef = useRef(null);
    const link = (process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_APP_URL : process.env.REACT_APP_APP_URL_DEV) + "company-user-verification?token=" + organization.token;

    return (
        <div id="company-signup-link-wrapper" className='flex-c'>
            <div id="company-signup-link">
                <div>
                    <h4>{organization.name.toUpperCase()}</h4>
                </div>
                <div>
                    <QRCodeCanvas value={link} size="180" imageSettings={{
                        src: "/assets/images/indi-logo-qr.png",
                        x: undefined,
                        y: undefined,
                        height: 25,
                        width: 40,
                        excavate: true,
                    }}
                        id="company-qr-canvas"
                    />
                </div>
                <div style={{ marginTop: "40px" }}>
                    <CustomButton onClick={() => {
                        const canvas = document.getElementById("company-qr-canvas");
                        const pngFile = canvas.toDataURL("image/png");
                        const downloadLink = document.createElement("a");
                        downloadLink.download = 'indi-onboarding-qr.png';
                        downloadLink.href = `${pngFile}`;
                        downloadLink.click();
                    }}>Download QR</CustomButton>
                    {/* <a ref={aRef} style={{ display: "none" }}>hidden</a> */}
                </div>
                <div id="copy-link-input-area">
                    <TextField
                        id="copy-link-input"
                        label=""
                        InputProps={{
                            value: link,
                            readOnly: true,
                            endAdornment: (
                                <InputAdornment position="start">
                                    <CopyToClipboard text={link}
                                        onCopy={() => {
                                            // setIsShowClipboard(true);
                                            // delay(() => {
                                            //     setIsShowClipboard(false);
                                            // }, 3000);
                                            toast.success("Copied to Clipboard!")
                                        }}>
                                        <ContentCopyIcon />
                                    </CopyToClipboard>
                                </InputAdornment>
                            ),
                        }}
                        variant="standard"
                    />
                </div>
            </div>
        </div>
    );
}

export default SignupLink;